import { Directive, Input, OnInit, HostListener, Renderer2, ElementRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PlatformDataService, UserInfoService, ShellDomainProvider, NotificationService, EcapTranslateService, UtilityService } from '@ecap3/core';
import { PlatformChatService } from '@ecap3/template-atlas';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { switchMap, map } from 'rxjs/operators';
import { IAppPlatformEntityBasedChatConfig, IEntityBasedChatInsertPayload, IAppPlatformEntitybasedChatCreationEventEmitPayload } from '../contracts/entity-based-chat.interface';
@Directive({ selector: '[eChat]' })

export class EntityBasedChatDirective implements OnInit {
    // LanguageKey = {
    //     'English': 'en-US',
    //     'French': 'fr-FR',
    //     'German': 'de-DE'
    // };
    EntityName = 'EntityBasedChat';
    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    chatSettings: any;
    // subjects = {
    //     'en': 'Optimizer',
    //     'de': 'Meine Nachrichten',
    //     'cz': 'Optizer'
    // };
    threadSubject: any;
    storedLang: any;
    @Input() config: IAppPlatformEntityBasedChatConfig;
    @Input() messageKey: any = "";
    @Input() LanguageKey: any = {
        'en': 'en-US',
        'de': 'de-DE',
        'fr': 'fr-FR',
        'sk': 'sk-SK',
        'cz': 'cs-CZ'
    }

    @HostListener('click', ['$event'])
    onClick(event?) {
        // event.preventDefault();
        // event.stopPropagation();
        if (this.config) {
            // disabling the element
            this.renderer.addClass(this.el.nativeElement, 'disabledElement');
            // ======================================================================
            // checking if already a thread is exists or not ========================
            // if no thread already been created then create a new thread ===========
            // ======================================================================
            this.checkChatStatus(this.config).subscribe((res: any) => {
                if (!res) {
                    // if has callback in the attribute
                    if (this.config.CallBack) {
                        this.config.CallBack();
                    } else {
                        this.createMailThread().subscribe((response: any) => {
                            if (response.ThreadId) {
                                // =========================================
                                // Entity based chat insert model start
                                // =========================================
                                const insertModel = this.generateInsertModel(this.config, response.ThreadId);
                                // ===========================================
                                // Entity based chat insert model end
                                // ===========================================
                                // =============================================================================
                                // connection between corresponding entity and 'EntityBasedChat' model start
                                // =============================================================================
                                this.config.TagsForConnection && this.config.TagsForConnection.length && this.config.TagsForConnection.push('EntityBasedChat-Of-Entity');
                                const Entity_EntityBasedChat_Connection_Model = {
                                    ItemId: this.utilityService.getNewGuid(),
                                    ChildEntityID: insertModel.ItemId,
                                    ChildEntityName: this.EntityName,
                                    ParentEntityID: this.config.TopicId,
                                    ParentEntityName: this.config.TopicEntityName,
                                    Tags: this.config.TagsForConnection
                                };

                                // ==========================================================================
                                // connection between corresponding entity and 'EntityBasedChat' model end ==
                                // if there is allowed usersId then proceed =================================
                                // else show error message using snackbar ===================================
                                // ==========================================================================
                                if (this.config.AllowedUserId) {
                                    this.pds.insert(this.EntityName, insertModel).subscribe((res: any) => {
                                        if (res && res.body && res.body.ErrorMessages && !res.body.ErrorMessages.length) {

                                            this.pds.connect(Entity_EntityBasedChat_Connection_Model).subscribe((conenctonResponse: any) => {

                                                if (conenctonResponse && conenctonResponse.body && conenctonResponse.body.ErrorMessages && !conenctonResponse.body.ErrorMessages.length) {
                                                    this.pds.getRowLevelSecurity(this.EntityName, insertModel.ItemId).subscribe((getRowSecurityResponse: any) => {
                                                        if (getRowSecurityResponse && getRowSecurityResponse.body && getRowSecurityResponse.body.ErrorMessages && !getRowSecurityResponse.body.ErrorMessages.length && getRowSecurityResponse.body.Results && getRowSecurityResponse.body.Results.length) {
                                                            if (getRowSecurityResponse.body.Results[0].IdsAllowedToRead) {
                                                                getRowSecurityResponse.body.Results[0].IdsAllowedToRead.push(this.config.AllowedUserId);
                                                                getRowSecurityResponse.body.Results[0].EntityName = this.EntityName;
                                                                if (getRowSecurityResponse.body.Results[0].IdsAllowedToUpdate && this.config && this.config.AllowUserIdForUpdate == true) {
                                                                    getRowSecurityResponse.body.Results[0].IdsAllowedToUpdate.push(this.config.AllowedUserId);
                                                                }
                                                                else if (this.config && this.config.AllowUserIdForUpdate == true) {
                                                                    getRowSecurityResponse.body.Results[0].IdsAllowedToUpdate = [this.config.AllowedUserId];
                                                                }
                                                                this.pds.changeSecurityPermissionWithRowLevelSecurity(getRowSecurityResponse.body.Results[0]).subscribe((securityUpdateResponse: any) => {
                                                                    if (securityUpdateResponse && securityUpdateResponse.body && securityUpdateResponse.body.ErrorMessages && !securityUpdateResponse.body.ErrorMessages.length) {
                                                                        const message = this.ecapTranslateService.instantTranslate('CHAT_CREATE_SUCCESS');
                                                                        this.showSnackBarMessages(message);
                                                                        // sending notification after a new entity based thread created
                                                                        this.sendNotificationAfterThread();
                                                                        // sending notification after a new entity based thread created ends
                                                                        if (this.chatSettings.openFloatingChat) {
                                                                            let createdChatTopic: IAppPlatformEntitybasedChatCreationEventEmitPayload = {
                                                                                TopicEntityName: this.config.TopicEntityName,
                                                                                PersonId: this.config.PersonId,
                                                                                TopicId: this.config.TopicId,
                                                                                Email: this.config.Email,
                                                                                ThreadId: response.ThreadId,
                                                                                TopicName: this.config.TopicName,
                                                                                SourceFrom: 'EntityBasedChat',
                                                                                defaultInputTextKey: this.config.defaultInputTextKey,
                                                                                Name: this.config.Name
                                                                            }
                                                                            if (this.config && this.config.Recipients) {
                                                                                createdChatTopic.Recipients = this.config.Recipients;
                                                                            }
                                                                            this.platformChatService.onFloatingChatEmits.emit(createdChatTopic);
                                                                            // this.platformChatService.onFloatingChatSelectionCall.emit();
                                                                        } else {
                                                                            this.router.navigate(['/chat'], {
                                                                                queryParams: {
                                                                                    location: 'other',
                                                                                    identifier: 'MessagingThreadNotification',
                                                                                    threadId: response.ThreadId,
                                                                                    topicEntityName: this.config.TopicEntityName,
                                                                                    topicId: this.config.TopicId,
                                                                                    personId: this.config.PersonId
                                                                                }
                                                                            });
                                                                        }
                                                                    }
                                                                }, (securityUpdateError: any) => {
                                                                    this.showSnackBarMessages(securityUpdateError);
                                                                });
                                                            } else {
                                                                const message = this.ecapTranslateService.instantTranslate('NO_SECURITY_IDSALLOWEDTOREAD');
                                                                this.showSnackBarMessages(message);
                                                            }
                                                        } else {
                                                            this.showSnackBarMessages(getRowSecurityResponse.body.ErrorMessages[0]);
                                                        }
                                                    }, (rowError: any) => {
                                                        this.showSnackBarMessages(rowError);
                                                    });
                                                } else {
                                                    this.showSnackBarMessages(conenctonResponse.body.ErrorMessages[0]);
                                                }
                                            });
                                        } else {
                                            this.showSnackBarMessages(res.body.ErrorMessages[0]);
                                        }
                                    }, (error: any) => {
                                        this.showSnackBarMessages(error);
                                    });
                                } else {
                                    const message = this.ecapTranslateService.instantTranslate('NO_USERID_PROVIDED');
                                    this.showSnackBarMessages(message);
                                }
                            } else {
                                this.showSnackBarMessages(response);
                            }
                        }, (error: any) => {
                            //  console.log(error);
                        });
                    }
                } else {
                    // enabling the element
                    this.renderer.removeClass(this.el.nativeElement, 'disabledElement');
                    if (this.chatSettings.openFloatingChat) {
                        let createdChatTopic: IAppPlatformEntitybasedChatCreationEventEmitPayload = {
                            TopicEntityName: this.config.TopicEntityName,
                            PersonId: this.config.PersonId,
                            TopicId: this.config.TopicId,
                            Email: this.config.Email,
                            ThreadId: res.MailThreadId,
                            TopicName: this.config.TopicName,
                            SourceFrom: 'EntityBasedChat',
                            defaultInputTextKey: this.config.defaultInputTextKey,
                            Name: this.config.Name
                        }
                        if (this.config && this.config.Recipients) {
                            createdChatTopic.Recipients = this.config.Recipients;
                        }
                        this.platformChatService.onFloatingChatSelectionCall.emit(createdChatTopic);
                    } else {
                        this.router.navigate(['/chat'], {
                            queryParams: {
                                location: 'other',
                                identifier: 'MessagingThreadNotification',
                                threadId: res.MailThreadId,
                                topicEntityName: this.config.TopicEntityName,
                                topicId: this.config.TopicId,
                                personId: this.config.PersonId
                            }
                        });
                    }
                }
            });
        } else {
            const message = this.ecapTranslateService.instantTranslate(this.messageKey || 'NO_CONFIGURATION_PROVIDED');
            this.showSnackBarMessages(message);
        }
    }

    constructor(private router: Router,
        private http: HttpClient,
        private snackBar: MatSnackBar,
        private pds: PlatformDataService,
        private platformChatService: PlatformChatService,
        private notificationService: NotificationService,
        private userInfo: UserInfoService,
        private el: ElementRef,
        private ecapTranslateService: EcapTranslateService,
        private renderer: Renderer2,
        private utilityService: UtilityService) {
    }

    ngOnInit() {
        this.chatSettings = this.platformChatService.getEntityBasedChatSettings();
        this.userInfo.currentUser.subscribe((result: any) => {
            if (result && result.UserId) {
                const matchedRole = this.arrdiff(result.Roles, this.chatSettings.activeForRoles);
                if (matchedRole && !matchedRole.length) {
                    this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
                }
            }
        });

        const langkey = this.ecapTranslateService.getTranslate().currentLang.trim().toLowerCase();
        if (this.storedLang !== langkey) {
            this.threadSubject = this.ecapTranslateService.instantTranslate("OPTIMIZER");// this.subjects[langkey];
            this.storedLang = langkey;
        }
    }

    /**
     * Title:generateInsertModel
     * Description: Generating insert model for entityBased Chat
     * param configInfo
     * return Object
     */
    generateInsertModel(configInfo: any, mailThreadId: string) {

        const langkey = this.ecapTranslateService.getTranslate().currentLang.trim().toLowerCase();

        const insertModel: IEntityBasedChatInsertPayload = {
            ItemId: this.utilityService.getNewGuid(),
            Language: this.LanguageKey[langkey] || 'en-US',
            Tags: ['Is-A-EntityBasedChat'],

            TopicName: configInfo.TopicName,
            TopicEntityName: configInfo.TopicEntityName,
            TopicId: configInfo.TopicId,
            Recipients: configInfo.Recipients,
            MailThreadId: mailThreadId
        };


        if (configInfo.MailThreadLastMessage) {
            insertModel.MailThreadLastMessage = {
                MessageBody: configInfo.MailThreadLastMessage.MessageBody,
                SentOn: configInfo.MailThreadLastMessage.SentOn,
            };
        }

        return insertModel;

    }

    /**
     * Title:createMailThread
     * Description: Creating mail thread
     * param void
     * return Observable
     */
    createMailThread(): Observable<any> {
        // ====================================================
        // needed to register new mail thread with this info ==
        // ====================================================
        const threadInfo = {
            Subject: this.threadSubject,
            DispatchTemplateName: this.utilityService.getMailDiscussionTemplate(),
            Tags: [
                'MessageThread-For-Chat'
            ],
            MailThreadId: this.utilityService.getNewGuid()
        };
        // ================================================
        // needed to register recipient with mailthread ===
        // ================================================
        const Mailreciever = {
            RecipientIds: this.config.Recipients,
            ThreadId: threadInfo.MailThreadId
        };
        // registering mail thread and recipients to get regular messages via chat window
        return this.http.post(ShellDomainProvider['api'].MessaginService + 'MailThreadingCommand/RegisterMailThread', threadInfo,
            { headers: this.header, withCredentials: true, observe: 'response' }).pipe(switchMap((response: any) => {
                // registering recipients with the mail thread to get regular messages via chat window
                if (response && response.body && response.body.ErrorMessages && !response.body.ErrorMessages.length) {
                    return this.http.post(ShellDomainProvider['api'].MessaginService + 'MailThreadingCommand/RegisterRecipients', Mailreciever,
                        { headers: this.header, withCredentials: true, observe: 'response' });
                } else {
                    //  console.log(response.body.ErrorMessages);
                }
            }), map((res: any) => {
                if (res && res.body && res.body.ErrorMessages && !res.body.ErrorMessages.length) {
                    return {
                        ThreadId: threadInfo.MailThreadId
                    };
                } else {
                    return res.body.ErrorMessages;
                }
            }, (err: any) => {
                //  console.log(err);
            }));
    }

    /**
     * Title:sendNotificationAfterReply
     * Description:sending notification after replying
     * @param
     * @return
     */
    sendNotificationAfterThread() {
        // notify endpoint payload
        // ResponseValue: response value will be shown instantly to whom is subscribed for this notification
        // DenormalizedPayload: denormalized payload will be saved to data for using getunread notification endpoint call
        const recieverUserId = this.config.AllowedUserId;
        // const currentThreadId = this.selectedContact.ThreadId;
        const payload = {
            UserIds: [recieverUserId],
            NotificationType: 'UserSpecificReceiverType',
            ResponseKey: 'NewThreadCreationNotification',
            SubscriptionFilters: [{
                Context: 'NewThreadCreationNotification'
            }],
            ResponseValue: JSON.stringify({}),
            DenormalizedPayload: JSON.stringify({})
        };
        // notify end point calling
        this.notificationService.nofity(payload).subscribe((result) => {
            if (result && result.body !== '') {
                //   console.log('notify done');
            } else {
                //  console.log('notification sending failed');
            }
        });
        // sending notify ends
    }

    /**
     * Title:checkChatStatus
     * Description: Checking if assets has any chat history or not
     * param assetsInformation<any>
     * return
     */
    checkChatStatus(assetInfo): Observable<any> {
        const Fields = ['ItemId', 'MailThreadId'];
        let query =`Select <${Fields.join()}> from <${this.EntityName}> where <TopicId=__eql(${assetInfo.TopicId})>`;
        if(assetInfo && assetInfo.Recipients && assetInfo.Recipients.length==2){
            query=`Select <${Fields.join()}> from <${this.EntityName}> where <TopicId=__eql(${assetInfo.TopicId}) & (Recipients=__eql(${assetInfo.Recipients[0]}) & Recipients=__eql(${assetInfo.Recipients[1]}))>`;
        }
        return this.pds.getBySqlFilter(this.EntityName, query, undefined).pipe(map((response: any) => {
            if (response && response['body'] && response['body'].Results.length) {
                return response['body'].Results[0];
            } else {
                return null;
            }
        }));
    }

    /**
     * Title: getIdUnmatchedId
     * Description: getting unmatched
     * param
     * return
     */
    getUnmatchedId(findArray, conditions) {
        const nonMatchingItems = findArray.filter(function (item) {
            return item != conditions;
        });
        return nonMatchingItems;
    }

    /**
     * Title:showSnackBarMessages
     * Description: showing snackbar message after any succesfull or failure occured
     * param
     * return
     */
    showSnackBarMessages(message: any) {
        this.snackBar.open(message, null, {
            duration: 2000,
            verticalPosition: 'top',
            horizontalPosition: 'end',
        });
        // enabling the element
        this.renderer.removeClass(this.el.nativeElement, 'disabledElement');
    }

    arrdiff(arr1, arr2) {
        const ret = [];
        //arr1.sort();
        //arr2.sort();
        for (let i = 0; i < arr1.length; i += 1) {
            if (arr2.indexOf(arr1[i]) > -1) {
                ret.push(arr1[i]);
            }
        }
        return ret;
    }
}
